"use client";

import getRtpState from "@casino/legacy/client/features/LiveRtp/modules/shared/helpers/getRtpState";
import type { FC } from "react";
import RtpArrow from "./RtpArrow";

type Props = { label: string; rtp?: number; rtpLive?: number };

// Providers supply neither figure reliably, so the strip can collapse to two columns or one.
const LiveRtpColumn: FC<Props> = ({ label, rtp, rtpLive }) => {
  if (!rtp || !rtpLive) return null;

  return (
    <div className="flex min-w-0 items-center justify-center gap-x-1">
      <span className="whitespace-nowrap text-xs text-muted-foreground">
        {label}
      </span>
      <span className="text-xs font-medium">{rtpLive}%</span>
      <RtpArrow state={getRtpState(rtp, rtpLive)} />
    </div>
  );
};

export default LiveRtpColumn;
